import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
// import { HashRouter  } from "react-router-dom";
// import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  //  <React.StrictMode>
  //  <HashRouter >
  <>

    <ToastContainer autoClose={1500}>
    </ToastContainer>
    <App />
  </>
  // </HashRouter>
  // </React.StrictMode> 
)

reportWebVitals();
